import React from 'react'
import "./UserInfo.css"
import { useParams } from 'react-router-dom';
import { Col, Container, Row } from 'react-bootstrap';
import { useSelector } from 'react-redux';

function UserInfo({ users }) {
  const { id } = useParams();
  const { currentLocal } = useSelector((state) => state.currentLocal);

  const user = users.filter(item => item.id == id);
  

  return (
    <div className='user_info_container mx-4'>
      <h3 className='mb-3'>{currentLocal.home.Customerdetails}</h3>
      <Container fluid>
        <Row>
          <Col md={6}>
            <div className='card mt-4'>
              <h4>{currentLocal.home.Customer} #{user && user[0].id}</h4>
              <h6>{user && user[0].name}</h6>
              <ul className='m-0 p-0'>
                <li>
                  <span className="key">{currentLocal.home.Contact}</span>
                  <span className="mx-3">:</span>
                  <strong className="value">{user && user[0].phone}</strong>
                </li>
                <li>
                  <span className="key">{currentLocal.home.emailPlaceholder}</span>
                  <span className="mx-3">:</span>
                  <strong className="value">{user && user[0].email}</strong>
                </li>
                <li>
                  <span className="key">  {currentLocal.home.Joineddate}                </span>
                  <span className="mx-3">:</span>
                  <strong className="value">{user[0]?.created_at}</strong>
                </li>

              </ul>
            </div>
          </Col>
          {/* <Col md={6}>
            <div className='card mt-4'>
              <h4 className='mb-4'>Saved address</h4>
              <>
                <Swiper className="mySwiper">
                  <SwiperSlide className='customer-address-card'>
                    <ul className="customer-details-new-card-content-list p-0">
                      <li>
                        <strong className="key  w-auto me-2 text-black">Name</strong>
                        <span className="mr-3">:</span>
                        <span className="value">Fatema</span>
                      </li>
                      <li>
                        <strong className="key  w-auto me-2 text-black">Phone</strong>
                        <span className="mr-3">:</span>
                        <span className="value">0**********</span>
                      </li>
                      <li>
                        <strong className="key w-auto me-2 text-black">Address</strong>
                        <span className="mr-3">:</span>
                        <span className="value">Shah Ali Plaza, Mirpur 10 Roundabout, Dhaka 1216, Bangladesh</span>
                      </li>
                    </ul>
                  </SwiperSlide>
                  <SwiperSlide className='customer-address-card'>Slide 2</SwiperSlide>
                  <SwiperSlide className='customer-address-card'>Slide 3</SwiperSlide>
                  <SwiperSlide className='customer-address-card'>Slide 4</SwiperSlide>
                  <SwiperSlide className='customer-address-card'>Slide 5</SwiperSlide>
                  <SwiperSlide className='customer-address-card'>Slide 6</SwiperSlide>
                  <SwiperSlide className='customer-address-card'>Slide 7</SwiperSlide>
                  <SwiperSlide className='customer-address-card'>Slide 8</SwiperSlide>
                  <SwiperSlide className='customer-address-card'>Slide 9</SwiperSlide>
                </Swiper>
              </>
            </div>
          </Col> */}
        </Row>
      </Container>
    </div>
  )
}

export default UserInfo